// Dynamic homepage statistics.
// Baseline values were set on BASE_DATE. Clients and projects grow by 1 every week;
// years of experience grow by 1 every year. Ratings are fixed and must match real reviews.
export const STATS_BASE_DATE = Date.UTC(2026, 10, 5); // 5 November 2026
export const STATS_BASE = {
  clients: 370,
  projects: 710,
  years: 9,
  rating: "4.9",
};

const DAY = 24 * 60 * 60 * 1000;

export const getStats = (now = new Date()) => {
  const elapsed = Math.max(0, now.getTime() - STATS_BASE_DATE);
  const weeks = Math.floor(elapsed / (7 * DAY));
  const years = Math.floor(elapsed / (365.2425 * DAY));
  return [
    { value: STATS_BASE.clients + weeks, suffix: "+", label: "Clients served", testId: "stat-clients" },
    { value: STATS_BASE.projects + weeks, suffix: "+", label: "Projects delivered", testId: "stat-projects" },
    { value: STATS_BASE.rating, suffix: "+", label: "Average client rating", testId: "stat-rating", raw: true },
    { value: STATS_BASE.years + years, suffix: "+", label: "Years of experience", testId: "stat-years" },
  ];
};
